import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  PageSettingsModel,
  QueryCellInfoEventArgs,
  RowSelectEventArgs,
} from "@syncfusion/ej2-angular-grids";
import { IMyDpOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import {
  EventEmitterBo,
  functionpermission,
  GetTaxBO,
  saveTimesheetBO,
  TimesheetBO,
} from "../timesheet.modal";
import { TimesheetService } from "../timesheet.service";
import { TimesheetEditService } from "./timesheet-edit.service";
@Component({
  selector: "app-timesheet-edit",
  templateUrl: "./timesheet-edit.component.html",
  styleUrls: ["./timesheet-edit.component.scss"],
})
export class TimesheetEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  EmployeeEditFilter: any;
  checkedTimesheetList: any = [];
  ClientEditFilter: any;
  serviceId: any;
  validateTotalAmount: number = 0;
  showTotalamount: any;
  createTimesheetList: any = [];
  TimesheetOrderList: any = [];
  ServiceEditFilter: any = [];
  EmployeePayrateList: any = [];
  PayerList: any = [];

  enteredhour: number = 0;
  enteredminutes: number = 0;
  FromDateFilter: any;
  AllTotalhours: string = "";
  saveTimesheetBO = new saveTimesheetBO();
  EmployeeMappedList: any = [];
  EndDateFilter: any;
  setTimesheetList: any = [];
  RelationshipEditFilter: any;
  RemainingAmountEditFilter: any;
  RateEditFilter: any;
  public formatOptions: object;
  isAuthorizationDetails: boolean = false;
  ActiveAuthorizationList: any = [];
  PayorEditFilter: any;
  getAuthorizationTax: any = [];
  serviceTaxable: boolean = false;
  RemainingTaxAmount: any;
  EmployerTax: boolean = false;
  HavingTax: boolean = false;
  TaxPercentAmount: any;
  SaveTaxList: GetTaxBO = new GetTaxBO();
  taxAvailbleInClientTab:any;
  taxAvailbleInTaxTab:any;
  TaxSaving: boolean = false;
  isTransportation:boolean=false;
 
 
  SaveReturn: boolean = false;
  isNoAuthorizationDetails: Boolean = false;
  public AuthorizationinitialPage: PageSettingsModel;
  @Input() EditInputProperty: EventEmitterBo = new EventEmitterBo();
  @Output() EditOutputTimesheet = new EventEmitter<EventEmitterBo>();
  saveTimesheetInfo: TimesheetBO = new TimesheetBO();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  };
  IsButtonDisable:boolean = false;
  constructor(
    private CDR: ChangeDetectorRef,
    public EditService: TimesheetEditService,
    public dateservice: DateService,
    public datePipe: DatePipe,
    public TService: TimesheetService,
    public TEditservice: TimesheetEditService,
    public global: GlobalComponent,
    public toasterservice: ToastrService,
    public general: GeneralService,
    public datepipe: DatePipe
  ) {}
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.AuthorizationinitialPage = { pageSize: 5 };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
  }
 
  //.......................................DateFormat.................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "SaveFromDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == "SaveEndDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "SaveFromDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.FromDateFilter = element;
          this.getActiveAuthorization();
          this.GetcheckedTimesheets();
          this.GetEmployeePayrate()?.then(() => {
            this.assignTimesheets();
          });        }
      }
      if (name == "SaveEndDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.EndDateFilter = element;
          this.getActiveAuthorization();
          this.GetcheckedTimesheets();
          this.GetEmployeePayrate()?.then(() => {
            this.assignTimesheets();
          });        }
      }
    }
  }
  //....................................rowSelected........................................................
  rowSelected(args: RowSelectEventArgs) {
    var rowList: any = args.data;

    this.RemainingAmountEditFilter = rowList.balanceAmount;
    this.PayorEditFilter = rowList.payor;
    this.RateEditFilter = rowList.rate;
    this.ServiceEditFilter = rowList.id;
    this.isTransportation=rowList.isTransportation == null? false:rowList.isTransportation;
    this.AllTotalhours=(this.AllTotalhours != null || this.AllTotalhours != undefined || this.AllTotalhours != '') ? "":"";
    console.log(this.isTransportation,"this.isTransportation")
    this.GetEmployeePayrate().then(() => {
      this.assignTimesheets();
    });    this.getTaxDetails();
  }
  //................................................customiseCell.....................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === "balanceAmount") {
      if (args.data[args.column.field] < 0) {
        args.cell.classList.add("mark");
      }
    }
  }
  //..................................................getRelationship.................................................
  getRelationship() {
    if (
      this.EmployeeEditFilter != null &&
      this.EmployeeEditFilter != undefined &&
      this.EmployeeEditFilter != ""
    ) {
      let a = this.EmployeeMappedList?.filter(
        (a) => a.employeeId == this.EmployeeEditFilter
      )[0];
      this.RelationshipEditFilter = a.relationship;
      this.clearEmployeeFields();
    } else {
      this.RelationshipEditFilter = null;
      this.EmployeeEditFilter = "";
      this.clearEmployeeFields();
    }
  }
  clearEmployeeFields() {
    this.ServiceEditFilter = "";
    this.RateEditFilter = null;
    this.FromDateFilter = "";
    this.EndDateFilter = "";
    this.PayorEditFilter = "";
    this.RemainingAmountEditFilter = null;
    this.validateTotalAmount = 0;
    this.showTotalamount = 0;
    this.AllTotalhours = "";
    this.enteredhour = 0;
    this.enteredminutes = 0;
    this.TimesheetOrderList = [];
    this.createTimesheetList = [];
    this.isAuthorizationDetails = false;
    this.isNoAuthorizationDetails = false;
  }
  //........................................GetMappedEmployees.......................................
  GetEmployeePayrate() {

    console.log("check");
    
    if (
      this.ClientEditFilter != null &&
      this.ClientEditFilter != undefined &&
      this.ClientEditFilter != "" &&
      this.EmployeeEditFilter != null &&
      this.EmployeeEditFilter != undefined &&
      this.EmployeeEditFilter != "" &&
      this.ServiceEditFilter != null &&
      this.ServiceEditFilter != undefined &&
      this.ServiceEditFilter != "" &&
      this.FromDateFilter != null &&
      this.FromDateFilter != undefined &&
      this.FromDateFilter != "" &&
      this.EndDateFilter != null &&
      this.EndDateFilter != undefined &&
      this.EndDateFilter != "" &&
      this.ActiveAuthorizationList.length > 0
    ) {
      let a = this.ActiveAuthorizationList?.filter(
        (a) => a.id == this.ServiceEditFilter
      )[0];
      this.serviceId = a.serviceId;  
      return new Promise((resolve, reject) => {
          let params = new URLSearchParams();
      params.append("clientId", this.ClientEditFilter);
      params.append("employeeId", this.EmployeeEditFilter);
      params.append("serviceId", this.serviceId);
      params.append(
        "start",
        this.global.getDateTimeString(this.FromDateFilter)
      );
      params.append("end", this.global.getDateTimeString(this.EndDateFilter));
      this.TEditservice.GetEmployeePayrateForClient(params)
      
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          this.EmployeePayrateList = data;
          
            resolve(data)
          }, (err) => {
            reject(err)
          });
        });

    }
  }
  //........................................GetMappedEmployees.......................................
  GetMappedEmployees() {
    if (
      this.ClientEditFilter != null &&
      this.ClientEditFilter != undefined &&
      this.ClientEditFilter != ""
    ) {
      this.clearFields();
      let params = new URLSearchParams();
      params.append("clientId", this.ClientEditFilter);
      this.TService.GetMappedEmployees(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          this.EmployeeMappedList = data;
        });
    } else {
      this.clearFields();
    }
  }
  clearFields() {
    this.ServiceEditFilter = "";
    this.EmployeeEditFilter = "";
    this.EmployeeMappedList = [];
    this.RateEditFilter = null;
    this.RelationshipEditFilter = "";
    this.FromDateFilter = "";
    this.EndDateFilter = "";
    this.PayorEditFilter = "";
    this.RemainingAmountEditFilter = null;
    this.validateTotalAmount = 0;
    this.showTotalamount = 0;
    this.AllTotalhours = "";
    this.enteredhour = 0;
    this.enteredminutes = 0;
    this.TimesheetOrderList = [];
    this.createTimesheetList = [];
    this.isAuthorizationDetails = false;
    this.isNoAuthorizationDetails = false;
  }
  //........................................getActiveAuthorization.......................................
  getActiveAuthorization() {
    if (
      this.ClientEditFilter != null &&
      this.ClientEditFilter != undefined &&
      this.ClientEditFilter != "" &&
       this.EmployeeEditFilter != null &&
      this.EmployeeEditFilter != undefined &&
      this.EmployeeEditFilter != "" &&
      this.FromDateFilter != null &&
      this.FromDateFilter != undefined &&
      this.FromDateFilter != "" &&
      this.EndDateFilter != null &&
      this.EndDateFilter != undefined &&
      this.EndDateFilter != ""
    ) {
      let params = new URLSearchParams();
      params.append("clientId", this.ClientEditFilter);
      params.append(
        "fromDate",
        this.global.getDateTimeString(this.FromDateFilter)
      );
      params.append(
        "toDate",
        this.global.getDateTimeString(this.EndDateFilter)
      );
      params.append("employeeId", this.EmployeeEditFilter);      
      this.TEditservice.getActiveAuthsWithinDateRange(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          this.ActiveAuthorizationList = data;

          this.ActiveAuthorizationList.forEach((authItems) => {
            authItems.id = authItems.id;
            authItems.fields = authItems.service + "," + authItems.serviceName;
          });
          if (data.length > 0) {
            this.isAuthorizationDetails = true;
            this.isNoAuthorizationDetails = false;
          } else {
            this.isAuthorizationDetails = false;
            this.isNoAuthorizationDetails = true;
            this.ActiveAuthorizationList = [];
            this.ServiceEditFilter = null;
          }
        });
    }
  }
  //........................................ApplyTotalHours.......................................
  ApplyTotalHours() {
    if (
      this.AllTotalhours != null &&
      this.AllTotalhours != undefined &&
      this.AllTotalhours != ""
    ) {
      this.TimesheetOrderList.forEach((element, index) => {
        let text = document.getElementById("editable_div" + index);
        text.innerHTML = this.AllTotalhours;
        element.hours = "";
        element.hours = this.AllTotalhours;
      });
      this.calculatehours(this.TimesheetOrderList);
    }
    this.validateTotalAmount = 0;
  }

  // ----------------------------------------CheckHoursExceed----------------------------------------
  // public checkHours: string;
  // CheckHoursExceeds(){
  //   let checkHours: TimesheetBO = JSON.parse(
  //     JSON.stringify(this.saveTimesheetInfo)
  //   );
  //   // let checkHours = 41;
  //   console.log("checkHours......" ,checkHours);
  //   console.log("TimesheetOrderList......" ,this.TimesheetOrderList);
  //   // if(checkHours > 40){
  //   //  this.toasterservice.error("Total Hours Exceeds. Remaining hours will considered as overtime rate")
  //   // }
  //   this.TEditservice.checkHoursExceed(checkHours).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.toasterservice.error("Total Hours Exceeds. Remaining hours will considered as overtime rate")
  //   })
  // }

  CheckHoursExceeds(){
    // let TimesheetOrderListData = this.TimesheetOrderList;
    // console.log("TimesheetOrderListData after click the apply button........", TimesheetOrderListData);
    // let hoursCheckPayload = {
    //   client: this.ClientEditFilter,
    //   employee: this.EmployeeEditFilter,
    //   startDate: this.FromDateFilter,
    //   endDate: this.EndDateFilter,
    //   hours: this.AllTotalhours,
    // }

      let checkHoursExceeds: TimesheetBO = JSON.parse(
      JSON.stringify(this.saveTimesheetInfo)
    );

    let TS;
      let Tj = 0;
      let setArrayList: any = [];
      for (TS = 0; TS < this.TimesheetOrderList.length; TS++) {
        if (
          !(
            this.TimesheetOrderList[TS].hours == "" ||
            this.TimesheetOrderList[TS].hours == 0 ||
            this.TimesheetOrderList[TS].hours == undefined
          )
        ) {
          let values = this.TimesheetOrderList[TS].hours;
          let Rate = this.TimesheetOrderList[TS].Rate;
          if (
            !(
              this.TimesheetOrderList[TS].hours == "" ||
              this.TimesheetOrderList[TS].hours == 0 ||
              this.TimesheetOrderList[TS].hours == undefined
            )
          ) {
            // let values = (this.TimesheetOrderList[i].hours.replace(/\s/g, "");
            setArrayList[Tj] = {
              Id: this.TimesheetOrderList[TS].Id,
              hours: parseFloat(values),
              Rate:
                Rate == null || Rate == undefined || Rate == ""
                  ? 0
                  : parseFloat(Rate),
              timesheetDate: this.global.getDateTimeString(
                this.TimesheetOrderList[TS].timesheetDate
              ),
              totalAmount: this.TimesheetOrderList[TS].totalAmount,
            };
            Tj++;
          }
        }
      }

    checkHoursExceeds.authorizationId = this.ServiceEditFilter;
    checkHoursExceeds.clientId = this.ClientEditFilter;
    checkHoursExceeds.employeeId = this.EmployeeEditFilter;
    checkHoursExceeds.timesheets = setArrayList;

    console.log("hoursCheckPayload data send to api....", checkHoursExceeds);

    // this.TEditservice.checkHoursExceed(checkHoursExceeds).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   console.log("data before enter to condition", data)
    //   if (data) {
    //     console.log("data", data)
    //     this.toasterservice.success(data);
    //   }
    // },
    //   (err: any) => {
    //     if (err) {
    //       this.toasterservice.error(err, 'Error'), 8000;
    //     }
    //   }
    // )
    // this.TEditservice.checkHoursExceed(checkHoursExceeds).pipe(takeUntil(this.onDestroy$)).subscribe(
    //   (data: any) => {
    //     console.log("Data from API:", data);
    //     if (Array.isArray(data)) {  
    //       data.forEach((message: string) => {
    //         this.toasterservice.error(message);
    //       });
    //     } else {
    //       this.toasterservice.error(data); 
    //     }
    //   },
    //   (err: any) => {
    //     if (err) {
    //       this.toasterservice.error(err, 'Error');
    //     }
    //   }
    // );
  }
  //.............................................saveTimesheethours.........................................................................................
  saveTimesheethours(event, i, TimesheetOrderList) {
    this.calculateTotalAmount(TimesheetOrderList);
    if (event.target.innerHTML == "") {
      this.TimesheetOrderList[i].hours = 0;
    } else {
      if (event.target.innerHTML == "") {
        this.TimesheetOrderList[i].hours = 0;
      } else {
        this.TimesheetOrderList[i].hours = event.target.innerHTML.replace(
          /\s/g,
          ""
        );
      }
      this.TimesheetOrderList[i].hours = event.target.innerHTML
        .toString()
        .replace(/\s/g, "");
      event.target.innerHTML = this.TimesheetOrderList[i].hours;
      this.calculatehours(this.TimesheetOrderList);
    }
    this.validateTotalAmount = 0;
    return true;
  }
  // ................................................calculatehours......................................................
  calculatehours(TimesheetOrderList) {
    let totalhours = TimesheetOrderList?.filter(t => t.hours != undefined && t.hours != null).map(t => t.hours).reduce((sum, sum1) => { return parseFloat(sum) + parseFloat(sum1) })
    let val5 = ((totalhours).toString()).split('.');
    if (val5.length == 2) {
      if (val5[val5.length - 1].length == 1) {
        val5[val5.length - 1] = parseInt(val5[val5.length - 1]) * 10;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0) {
        this.enteredhour = val5[0];
        this.enteredminutes = 0;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.25) {
        this.enteredhour = val5[0];
        this.enteredminutes = 15;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.5) {
        this.enteredhour = val5[0];
        this.enteredminutes = 30;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.75) {
        this.enteredhour = val5[0];
        this.enteredminutes = 45;
      }
    } 
    else {
      this.enteredhour = val5[0];
      this.enteredminutes = 0;
    }

    this.calculateTotalAmount(TimesheetOrderList);
  }
  //................................................calculateTotalAmount.......................................
  calculateTotalAmount(TimesheetOrderList) {
    this.showTotalamount = 0;
    TimesheetOrderList.forEach((element) => {
      if (
        element.Rate != 0 &&
        element.Rate != undefined &&
        element.Rate != null &&
        element.hours != 0 &&
        element.hours != null &&
        element.hours != undefined
      ) {
        element.totalAmount = parseFloat((element.Rate * element.hours).toFixed(2));
        this.showTotalamount += element.totalAmount;

      } else {
        element.totalAmount = null;
      }
    });
    this.showTotalamount=parseFloat(this.showTotalamount).toFixed(2)

  }
  Rate = 0;
  WithOutClient = '';
  WithClient = ''
  End = ''
  withoutclient: boolean = false;

  getPayrate(date) {

    this.EmployeePayrateList.forEach(element => {

      if ((new Date(element.fromDate)) <= (new Date(date)) &&

        (new Date(element.toDate)) >= (new Date(date))) {          

        if (element.clientId != null && element.clientId != undefined && element.clientId != '') {        

          this.Rate=element.rate;    

        }
        else if(this.Rate!=null && this.Rate!=undefined && this.Rate!=0)
         {          
           return this.Rate

        }
        else{
          this.Rate=element.rate

        }
      } 

    });

}
  //..........................................assignTimesheets........................................
  async assignTimesheets() {
    if (
      this.ServiceEditFilter != null &&
      this.ServiceEditFilter != "" &&
      this.ServiceEditFilter != undefined &&
      this.ServiceEditFilter != "" &&
      this.FromDateFilter != null &&
      this.FromDateFilter != undefined &&
      this.FromDateFilter != "" &&
      this.EndDateFilter != null &&
      this.EndDateFilter != undefined &&
      this.EndDateFilter != ""
    ) {
      if (
        new Date(this.FromDateFilter).getTime() <
          new Date(this.EndDateFilter).getTime() ||
        this.FromDateFilter == this.EndDateFilter
      ) {
        {
          this.TimesheetOrderList = [];
          var timesheetdata: any = [];
          if (
            this.ServiceEditFilter != null &&
            this.ServiceEditFilter != "" &&
            this.ServiceEditFilter != undefined &&
            this.ServiceEditFilter != ""
          ) {
            timesheetdata = await this.GetcheckedTimesheets().then(
              (res: any) => {
                return res;
              }
            );
            this.checkedTimesheetList = await this.GetcheckedTimesheets().then(
              (res: any) => {
                return res;
              }
            );
          }
          var FromDate = new Date(this.FromDateFilter);
          var EndDate = new Date(this.EndDateFilter);
          var daysDifferent = Math.floor(
            (Date.UTC(
              EndDate.getFullYear(),
              EndDate.getMonth(),
              EndDate.getDate()
            ) -
              Date.UTC(
                FromDate.getFullYear(),
                FromDate.getMonth(),
                FromDate.getDate()
              )) /
              (1000 * 60 * 60 * 24)
          );
          for (let i: number = 0; i <= daysDifferent; i++) {
            var Value1 = new Date(FromDate);
            Value1.setDate(Value1.getDate() + i);
            let hours;
            let booleanValidation = false;
            let timesheetid = "00000000-0000-0000-0000-000000000000";
            if (timesheetdata.length != 0) {
              timesheetdata.forEach(element => {
                let today = this.datePipe.transform(element.date, 'MM/dd/yyyy');
                if (today == this.datePipe.transform(Value1, 'MM/dd/yyyy') && element.employee == this.EmployeeEditFilter &&
                  element.client == this.ClientEditFilter && element.authId == this.ServiceEditFilter) {
                  booleanValidation =true;
                  timesheetid = element.id;
                  hours = element.totalhour != null ? element.totalhour : "";
                }
              });
            } else {
              hours = "";
            }
            var Value2: any = new Date(Value1).getDay();
            switch (Value2) {
              case 0:
                Value2 = "Sunday";
                break;
              case 1:
                Value2 = "Monday";
                break;
              case 2:
                Value2 = "Tuesday";
                break;
              case 3:
                Value2 = "Wednesday";
                break;
              case 4:
                Value2 = "Thursday";
                break;
              case 5:
                Value2 = "Friday";
                break;
              case 6:
                Value2 = "Saturday";
            }

            this.getPayrate(Value1);
            let AuthService = this.ActiveAuthorizationList?.filter(s => s.id == this.ServiceEditFilter)[0];
            let Fields = AuthService.service + "," + AuthService.serviceName;
            this.createTimesheetList = {
              Id:
                timesheetid != ""
                  ? timesheetid
                  : "00000000-0000-0000-0000-000000000000",
              Days: Value2,
              isHighlighted: booleanValidation,
              timesheetDate: (new Date(Value1).getMonth() + 1) + '/' + new Date(Value1).getDate() + '/' + new Date(Value1).getFullYear(),
              // Rate: (this.Rate == undefined || this.Rate == null || this.Rate == 0 
              //   ) ? this.RateEditFilter : this.Rate,
              Rate: this.RateEditFilter,
              Authorizationservice: Fields,
              hours: hours != "" ? hours : "",
              totalAmount: 0,
            }
            this.Rate=0
            this.TimesheetOrderList.push(this.createTimesheetList);
          }
        }
      }
      this.calculateTotalAmount(this.TimesheetOrderList);
      if (this.checkedTimesheetList.length > 0) {
        this.calculatehours(this.TimesheetOrderList);
      }
    } else {
      this.enteredhour = 0;
      this.enteredminutes = 0;
      // this.RemainingAmountEditFilter = null;
      // this.PayorEditFilter = null;
    }
  }
  //......................................................GetcheckedTimesheets...................................................
  GetcheckedTimesheets() {
    if (
      this.ClientEditFilter != null &&
      this.ClientEditFilter != undefined &&
      this.ClientEditFilter != "" &&
      this.EmployeeEditFilter != null &&
      this.EmployeeEditFilter != undefined &&
      this.EmployeeEditFilter != "" &&
      this.ServiceEditFilter != null &&
      this.ServiceEditFilter != undefined &&
      this.ServiceEditFilter != "" &&
      this.FromDateFilter != null &&
      this.FromDateFilter != undefined &&
      this.FromDateFilter != "" &&
      this.EndDateFilter != null &&
      this.EndDateFilter != undefined &&
      this.EndDateFilter != ""
    ) {
      return new Promise((resolve, reject) => {
        let params = new URLSearchParams();
        params.append("clientId", this.ClientEditFilter);
        params.append("employeeId", this.EmployeeEditFilter);
        params.append("authId", this.ServiceEditFilter);
        params.append(
          "fromDate",
          this.global.getDateTimeString(this.FromDateFilter)
        );
        params.append(
          "toDate",
          this.global.getDateTimeString(this.EndDateFilter)
        );
        this.TEditservice.checkTimesheets(params)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data: any) => {
              resolve(data);
            },
            (err) => {
              reject(err);
            }
          );
      });
    }
  }
  // .................................................numberonly........................................................................
  numberonly(event: any, TimesheetType) {
    console.log(event,"event")
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (
      ((event.which < 48 &&
        event.which != 8 &&
        event.which != 46 &&
        event.which != 39 &&
        event.which != 37) ||
        event.which > 57) &&
      ((event.which < 96 &&
        event.which != 8 &&
        event.which != 46 &&
        event.which != 39 &&
        event.which != 37) ||
        event.which > 105)
    ) {
      event.preventDefault();
    }
    let text = "";
    if (TimesheetType == "create") {
      text = event.target.innerHTML;
    }
    if (TimesheetType == "All") {
      text = this.AllTotalhours;
    }
    text = text.trim ? text.trim() : text.replace(/^\s+/, "");
    console.log(text.length,"text.length");
    if (text.length == 1) {
      if (text == "2") {
        if (event.key > 3) {
          event.preventDefault();
        }
      }
      if (parseInt(text) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (text == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          event.preventDefault();
        }
      }
    }
    if (text.length == 2) {
      let array = text.split("");
      if (!(array[1] == ".")) {
        if (array[0] == ".") {
          if (array[1] == "5" || array[1] == "0") {
            if (!(event.which == 48)) {
           //   event.preventDefault();
            }
          }
          if (array[1] == "2" || array[1] == "7") {
            if (!(event.which == 53)) {
             // event.preventDefault();
            }
          }
        } else if (event.which != 46) {
          event.preventDefault();
        }
      } else {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
         // event.preventDefault();
        }
      }
    }
    if (text.length == 3) {
      let array = text.split("");
       console.log(array,"array")
      if (array[0] == ".") {
        event.preventDefault();
      }
      if (array[2] == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
         // event.preventDefault();
        }
      }
      if (array[1] == ".") {
        let List = text.split(".");
        console.log(List[1],"List[1]");
        if (List[1] == "5" || List[1] == "0" || List[1] == "3") {
          if (!(event.which == 48)) {
          //  event.preventDefault();
          }
        }
        if (List[1] == "2" || List[1] == "7") {
          if (!(event.which == 53)) {
          //  event.preventDefault();
          }
        }
      }
    }
    if (text.length == 4) {
      
      let type = text.split(".");
      if (type[1].length == 2) {
      //  event.preventDefault();
      }
      if (type[1] == "5" || type[1] == "0") {
        if (!(event.which == 48)) {
        //  event.preventDefault();
        }
      }
      if (type[1] == "2" || type[1] == "7") {
        if (!(event.which == 53)) {
        //  event.preventDefault();
        }
      }
    }
    let val = text.split(".");
    if (text.length > 4) {
      event.preventDefault();
    }
  }
  numbersOnlyS2015Validation(event: any, type) {
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let txt = "";
    if (type == "create") {
      txt = event.target.innerHTML;
    }
    
    if (type == "All") {
      txt = this.AllTotalhours;
    }
    txt = (txt.trim) ? txt.trim() : txt.replace(/^\s+/, '');
    console.log(txt,"txt");
    // length 1
    if (txt.length == 1) {
      if (txt == "10") {

        if (event.key > 4) {

          event.preventDefault();
        }

      }

      if (parseInt(txt) > 9) {

        if (event.which != 50) {
          event.preventDefault();
        }
      }
      if (txt == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }


    }
    //  length 2
    if (txt.length == 2) {
      let tempdata = txt.split("");
      if (!(tempdata[1] == ".")) {
        if (tempdata[0] == ".") {

          if (tempdata[1] == "5" || tempdata[1] == "0") {

            if (!(event.which == 48)) {


             // event.preventDefault();
            }
          }
          if (tempdata[1] == "2" || tempdata[1] == "9") {

            if (!(event.which == 53)) {


             // event.preventDefault();
            }
          }
        }
        else if (event.which != 46) {
        //  event.preventDefault();
        }
      }
      else {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    // length 3
    if (txt.length == 3) {
      let tempdata = txt.split("");
      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {


         // event.preventDefault();
        }

      }
      if (tempdata[1] == ".") {

        let tempdata1 = txt.split(".");

        if (tempdata1[1] == "5" || tempdata1[1] == "0") {

          if (!(event.which == 48)) {


          //  event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {

          if (!(event.which == 53)) {


           // event.preventDefault();
          }
        }
      }
    }
    // length 4
    if (txt.length == 4) {
      let tempdata = txt.split(".");
      if (tempdata[1].length == 2) {
       // event.preventDefault();
      }
      if (tempdata[1] == "5" || tempdata[1] == "0") {

        if (!(event.which == 48)) {


         // event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {

        if (!(event.which == 53)) {


         // event.preventDefault();
        }
      }
    }
    if (txt.length > 4) {
      event.preventDefault();
    }
  }
  exceedTaxAmount() {
    this.SaveReturn=false;
    let deductAmount: any;
    deductAmount = this.showTotalamount;
 
    if (this.serviceTaxable == true) {
      if (
        this.EmployerTax == false ||
        this.HavingTax == false ||  this.taxAvailbleInClientTab == false &&  this.taxAvailbleInTaxTab ==false ||
        this.TaxPercentAmount == 0) {
        document.getElementById("taxExceedModal").click();
      } 
      else if (this.EmployerTax == true && this.HavingTax == true  ||  this.taxAvailbleInClientTab == true ||  this.taxAvailbleInTaxTab ==true && this.TaxPercentAmount > 0 ) {
        deductAmount = (deductAmount * this.TaxPercentAmount) / 100;
        if (deductAmount > this.RemainingTaxAmount ) {
          this.SaveReturn=false;
          document.getElementById("taxExceedModal").click();
        } 
        else  {
          
          this.SaveReturn=false;
          this.taxSaving();
        }
      } 
    
      // else {
      //   this.taxSaving();
      // }
    } 
    else {
      this.SaveReturn=false;
       this.taxSaving();
    }
  }
  SaveTimesheets() {

    this.IsButtonDisable = true;
    let savepayload: TimesheetBO = JSON.parse(
      JSON.stringify(this.saveTimesheetInfo)
    );
    let validateTotalHours = 0;
    this.TimesheetOrderList.forEach((element) => {
      if (element.hours == 0 || element.hours == "" || element.hours == null) {
        validateTotalHours = validateTotalHours + 1;
      }
    });
    if (validateTotalHours == this.TimesheetOrderList.length) {
      this.IsButtonDisable = false;
      this.toasterservice.error("Please enter Total Hours", "error");
      return;
    }
    if (this.validateTotalAmount == 0) {
      if (this.showTotalamount > this.RemainingAmountEditFilter) {
        this.IsButtonDisable = false;
        document.getElementById("openValidationModal").click();
        this.validateTotalAmount = this.validateTotalAmount + 1;
         return;
      } else {
        this.IsButtonDisable = false;
        this.exceedTaxAmount();
        return;
      }
    }
    if (this.SaveReturn == true) {
      let TS;
      let Tj = 0;
      let setArrayList: any = [];
      for (TS = 0; TS < this.TimesheetOrderList.length; TS++) {
        if (
          !(
            this.TimesheetOrderList[TS].hours == "" ||
            this.TimesheetOrderList[TS].hours == 0 ||
            this.TimesheetOrderList[TS].hours == undefined
          )
        ) {
          let values = this.TimesheetOrderList[TS].hours;
          let Rate = this.TimesheetOrderList[TS].Rate;
          if (
            !(
              this.TimesheetOrderList[TS].hours == "" ||
              this.TimesheetOrderList[TS].hours == 0 ||
              this.TimesheetOrderList[TS].hours == undefined
            )
          ) {
            // let values = (this.TimesheetOrderList[i].hours.replace(/\s/g, "");
            setArrayList[Tj] = {
              Id: this.TimesheetOrderList[TS].Id,
              hours: parseFloat(values),
              Rate:
                Rate == null || Rate == undefined || Rate == ""
                  ? 0
                  : parseFloat(Rate),
              timesheetDate: this.global.getDateTimeString(
                this.TimesheetOrderList[TS].timesheetDate
              ),
              totalAmount: this.TimesheetOrderList[TS].totalAmount,
            };
            Tj++;
          }
        }
      }
      savepayload.authorizationId = this.ServiceEditFilter;
      savepayload.clientId = this.ClientEditFilter;
      savepayload.employeeId = this.EmployeeEditFilter;
      savepayload.timesheets = setArrayList;
   
      this.TEditservice.saveTimesheet(savepayload)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.IsButtonDisable = false;
            this.toasterservice.success("Timesheets saved successfully!");
             this.SaveReturn=false;
            setTimeout(() => {
              this.toasterservice.clear();
            }, 8000);
            this.backtoTimesheetList();
          },
          (err: any) => {
            this.IsButtonDisable = false;
            if (err) {
              this.toasterservice.error(err, "Error"), 8000;
            }
          }
        );
    }
  }
 
  //.............................................................backtoTimesheetList..........................................
  backtoTimesheetList() {
    this.EditInputProperty.isCreate = false;
    this.EditOutputTimesheet.emit(this.EditInputProperty);
  }
  //......................................................cancelValidation........................................
  cancelValidation() {
    this.validateTotalAmount = 0;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
   //----------------------------------------------CheckTaxPercent---------------------------------------------------------////

 getTaxDetails() {
   let getTaxData: GetTaxBO = JSON.parse(JSON.stringify(this.SaveTaxList));
   getTaxData.authorizationId = this.ServiceEditFilter;
   getTaxData.clientId = this.ClientEditFilter;
   getTaxData.employeeId = this.EmployeeEditFilter;
   getTaxData.startDate = this.global.getDateTimeString(this.FromDateFilter);
   getTaxData.endDate = this.global.getDateTimeString(this.EndDateFilter);


   this.TEditservice.getTaxListDetails(getTaxData)
     .pipe(takeUntil(this.onDestroy$))
     .subscribe((data: any) => {
       this.getAuthorizationTax = data;
       this.getAuthorizationTax.forEach((e) => {
         this.serviceTaxable = e.servicetaxable;
         this.EmployerTax = e.authemployertax;
         this.HavingTax = e.eerelationtaxname;
         this.taxAvailbleInClientTab=e.eerelationtaxpercent;
         this.taxAvailbleInTaxTab=e.taxpercent;
         this.TaxPercentAmount = e.employertaxpercent;
         this.RemainingTaxAmount = e.remainingtaxamt;
       });
     });
 }


 taxSaving() {
   
   this.validateTotalAmount = this.validateTotalAmount + 1;
   this.SaveReturn = true;
   this.SaveTimesheets();
 }

 clearfields()
 {
  if(this.FromDateFilter==null||this.FromDateFilter==undefined||this.FromDateFilter==''||
  this.EndDateFilter==null||this.EndDateFilter==undefined||this.EndDateFilter=='')
  {
 this.ServiceEditFilter = ""
 this.RemainingAmountEditFilter = ""
 this.PayorEditFilter = ""
  }
 }
 


}

